import { PATH } from 'src/pages/shortLink'
import loadable from 'src/utils/Loadable'
import { IRouter } from 'src/interfaces/route'

const ShortLinkRoute: IRouter[] = [
  {
    path: PATH.SHORT_LINK_REDIRECT,
    element: loadable(() => import('src/pages/shortLink')),
  },
]

export default ShortLinkRoute
